module.exports = __webpack_public_path__ + "img/7.448e367c.jpeg";